/******************
 * Prevent scrolling on page and in all elements except for the target
 * Advanced usage and option definitions can be found: https://www.npmjs.com/package/body-scroll-lock
 * Usage:
		const mobileNav = document.querySelector('.mobileNav') // Element that will be allowed to scroll
		-------Disable Scrolling---------
			bodyLock.lock(myScrollingElement) // Disables body scroll while enabling scroll on target element
		-------Re-enable Scrolling-------
			bodyLock.unlock(myScrollingElement) // Enables body scroll and removing listeners on target element
		-----or-----
			bodyLock.clear() // Clears all scroll locks
******************/
import bodyScrollLock from 'body-scroll-lock';
import {util} from '~/core'

const bodyLock = {
	lock(target, options = {}) {
		bodyScrollLock.disableBodyScroll(target, options);
	},
	unlock(target, options = {}) {
		bodyScrollLock.enableBodyScroll(target, options);
	},
	clear(options = {}) {
		bodyScrollLock.clearAllBodyScrollLocks(options);
	}
};
export default bodyLock

util.bodyLock = bodyLock